import { getI18n } from 'react-i18next';

export const FATAL_ERROR = 'error.fatal';

export const createFatalErrorMessage = (code) => {
    switch (code) {
        case FATAL_ERROR:
            return getI18n().t('errors.graphql');
        default:
            return undefined;
    }
};
